// Imports for external libraries go here.
import { FC, useContext } from 'react';
// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
// The closer the import is to the file the lower it should be in this list.
import { SetPassword } from '../../molecules';
import { ChangePasswordProps } from './ChangePassword.types';
import { StyledChangePassword, FlyOutModalStyle } from './ChangePassword.styles';
import { PageContext } from '../../modules';

// Use named rather than default exports.
export const ChangePassword: FC<ChangePasswordProps> = ({
  model,
  isDTT,
  enablePhaseOne,
  enablePhaseThree,
  uxlFailureBannerText,
  stepCounter,
  accountEvent,
  isFlyout,
}) => {
  const clientEnvVars = useClientEnvVarsStore.getState().envVarsObject;
  const { TRACKING_PAGE_NAME: pageName } = clientEnvVars;
  const pageContext = useContext(PageContext);
  const isResetTokenValid = pageContext?.isResetTokenValid ?? false;

  return (
    <StyledChangePassword
      className="container mb-5 px-0"
      data-testid="changepassword"
      data-component-name="o-account-changepassword"
    >
      <div className={!enablePhaseOne ? 'row' : ''}>
        <div className={!enablePhaseOne ? 'col-12 col-lg-5 col-md-8' : ''}>
          <SetPassword
            authorModelData={model}
            isChangePwrd={true}
            isFormDisabled={false}
            isResetTokenValid={isResetTokenValid}
            isDTT={isDTT}
            trackingPageName={pageName}
            enablePhaseOne={enablePhaseOne}
            enablePhaseThree={enablePhaseThree}
            uxlFailureBannerText={uxlFailureBannerText}
            stepCounter={stepCounter}
            accountEvent={accountEvent}
            isFlyout={isFlyout}
          />
        </div>
      </div>
      {enablePhaseOne && <FlyOutModalStyle />}
    </StyledChangePassword>
  );
};

export const ChangePasswordConfig = {
  emptyLabel: 'changepassword',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/changepassword`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ChangePasswordEditable = (props: any) => {
  return (
    <EditableComponent config={ChangePasswordConfig} {...props}>
      <ChangePassword {...props} />
    </EditableComponent>
  );
};
